var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBedBoldSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4516 7.16121H3.93548V5.54831C3.93548 5.29165 3.83353 5.0455 3.65204 4.86401C3.47055 4.68252 3.2244 4.58057 2.96774 4.58057C2.71108 4.58057 2.46493 4.68252 2.28345 4.86401C2.10196 5.0455 2 5.29165 2 5.54831V18.4515C2 18.7082 2.10196 18.9543 2.28345 19.1358C2.46493 19.3173 2.71108 19.4193 2.96774 19.4193C3.2244 19.4193 3.47055 19.3173 3.65204 19.1358C3.83353 18.9543 3.93548 18.7082 3.93548 18.4515V16.1935H20.0645V18.4515C20.0645 18.7082 20.1665 18.9543 20.348 19.1358C20.5294 19.3173 20.7756 19.4193 21.0323 19.4193C21.2889 19.4193 21.5351 19.3173 21.7166 19.1358C21.898 18.9543 22 18.7082 22 18.4515V10.7096C21.9989 9.76883 21.6247 8.86691 20.9595 8.20168C20.2943 7.53646 19.3924 7.16227 18.4516 7.16121ZM3.93548 9.0967H9.09677V14.258H3.93548V9.0967ZM11.0323 14.258V9.0967H18.4516C18.8792 9.09718 19.2892 9.26727 19.5916 9.56964C19.8939 9.87202 20.064 10.282 20.0645 10.7096V14.258H11.0323Z",
    fill: "#9393B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedBoldSvgrepocom);
export default __webpack_public_path__ + "static/media/bed-bold_svgrepo.com.5f63c7d7a2eeeff23c957781c6642149.svg";
export { ForwardRef as ReactComponent };